import {default as PhoneInput} from './PhoneInput.svelte';
import type {BaseInputProps} from 'Catalyst/components/BaseInput';
import {baseInputTvProps} from 'Catalyst/components/BaseInput';
import {type VariantProps, tv} from 'tailwind-variants';

export type PhoneInputOwnProps = Partial<{
  initialCountry: string;
  value: string;
  displayValue: string;
  name: string;
}>;

export const phoneInputTvProps = tv({
  extend: baseInputTvProps,
  slots: {
    phoneInputWrapper: '',
    base: '[&_.iti--allow-dropdown]:w-full',
    input: '',
  },
  variants: {
    floating: {
      false: {
        phoneInputWrapper: '[&_label]:translate-x-[50px]',
      },
    },
    hidePlaceholder: {
      true: {
        input: 'placeholder:opacity-0',
      },
    },
  },
});
export type PhoneInputTvProps = VariantProps<typeof phoneInputTvProps>;
export type PhoneInputProps = BaseInputProps &
  PhoneInputOwnProps &
  PhoneInputTvProps;

export {PhoneInput};
